/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InternshipApplication } from '../../models/internship-application';

export interface GetInternshipApplications$Params {
  pendingOnly?: boolean;
  confirmedOnly?: boolean;
}

export function getInternshipApplications(http: HttpClient, rootUrl: string, params?: GetInternshipApplications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InternshipApplication>>> {
  const rb = new RequestBuilder(rootUrl, getInternshipApplications.PATH, 'get');
  if (params) {
    rb.query('pendingOnly', params.pendingOnly, {});
    rb.query('confirmedOnly', params.confirmedOnly, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InternshipApplication>>;
    })
  );
}

getInternshipApplications.PATH = '/internshipapplications';
